import React, { createContext, useState } from 'react';

export interface SearchContextProps {
  term: string;
  setTerm: (term: string) => void;
}

export const SearchContext = createContext<SearchContextProps>({
  term: '',
  setTerm: () => {},
});
SearchContext.displayName = 'SearchContext';

export const SearchProvider: React.FC = ({ children }) => {
  const [term, setTerm] = useState<string>('');

  return (
    <SearchContext.Provider value={{ term, setTerm }}>
      {children}
    </SearchContext.Provider>
  );
};
